// extracted by mini-css-extract-plugin
export var color = "centerTextSection-module--color--cdd1e";
export var wrapper = "centerTextSection-module--wrapper--1902c";
export var wrapperB = "centerTextSection-module--wrapperB--79476";
export var wrapperT = "centerTextSection-module--wrapperT--d395a";
export var wrappert = "centerTextSection-module--wrappert--5feef";